import React, { useState } from 'react';
import {  useNavigate } from "react-router-dom";

// Definición del componente funcional ImpuestosForm
const ImpuestosForm = ({ submitCallback }) => {
  // Definir estados locales para cada campo del formulario
  const [nombre, setNombre] = useState('');
  const [primerApellido, setPrimerApellido] = useState('');
  const [segundoApellido, setSegundoApellido] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const navigate = useNavigate() 

  
  // Función para manejar el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    const url = `/busqueda-impuestos?nombre=${nombre}&primerApellido=${primerApellido}&segundoApellido=${segundoApellido}&razonSocial=${razonSocial}`
  
    navigate(url)
  }


  // Renderizar el formulario
  return (
    <form className="questionnaire" onSubmit={handleSubmit}>
      {/* Renderizar los campos del formulario */}
      <div className="question">
        <label>
          Nombre:
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Primer Apellido:
          <input type="text" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Segundo Apellido:
          <input type="text" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Razón Social:
          <input type="text" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} />
        </label>
      </div>
      {/* Botón de envío del formulario */}
      <button className='button2' type="submit">Buscar</button>
    </form>
  );
};

// Exportar el componente ImpuestosForm
export default ImpuestosForm;
